var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
/* eslint-disable camelcase */
import { FeedPressureType, SystemModel, } from "./types";
import { systemDataConstants } from "api/system-data";
import { NodeComponentType, TubeConnectionId, } from "store/types";
import { tubeConnectionModels, toolChangerDefaultLength, feedPressurePointNodeId, } from "3d/constants/common";
import { getCylinderVolumeDm3 } from "3d/helpers";
import { selectors } from "store/selectors";
export var getPumpProperties = function (pump) { return ({
    model: pump.model,
    ejector_model: pump.ejectorModel,
    number_of_ejectors: pump.ejectorCount,
}); };
export var getCupProperties = function (cup) { return ({
    model_code: cup.modelCode,
}); };
export var getCupMountingProperties = function (cupMounting) { return ({
    model: cupMounting.model,
    volume: cupMounting.volume,
    diameter: cupMounting.diameter,
}); };
var Network;
(function (Network) {
    Network["DEFAULT"] = "default";
    Network["BLOW_OFF"] = "blow_off";
})(Network || (Network = {}));
var getNetworkId = function (sceneId, network) {
    return "".concat(network, "-").concat(sceneId);
};
export var serializeStateToRequest = function (state, energySavingOn) {
    var cupsOutsideOfObject = state.systemPerformance.cupsOutsideOfObject;
    var edges = selectors.selectEdges(state);
    var nodes = selectors.selectNodes(state);
    var attachments = selectors.selectAttachments(state);
    var hasDoubleCompressedAirConnections = selectors.selectUseDoubleCompressedAirTubes(state);
    /* API IDs are number 0-255*/
    var availableApiIds = __spreadArray([], __read(Array(255).keys()), false).reverse();
    var getId = function () {
        var id = availableApiIds.pop();
        if (id === undefined) {
            throw Error("Not enough IDs");
        }
        return id;
    };
    var handledObjectId = getId();
    var noHandledObjectId = getId();
    /*
     * Create a simplified network representation of nodes/edges, where
     * each node/edge has an API Id and a list of edges/nodes
     * it is connected to.
     *
     * For double tube networks, each node/edge positioned between the
     * feed pressure point and a pump will exist twice. Once in the default
     * network and once in the blow off network.
     */
    var networkIdsPartial = {};
    var addToNetwork = function (sceneId, network, networkConnections) {
        var networkId = getNetworkId(sceneId, network);
        var ids = {
            networkId: networkId,
            network: network,
            sceneId: sceneId,
            apiId: getId(),
            networkConnections: networkConnections,
        };
        networkIdsPartial[networkId] = ids;
    };
    var populatePartialNetwork = function (node, addToBlowOffNetwork, additionalNetworkConnections) {
        if (addToBlowOffNetwork === void 0) { addToBlowOffNetwork = false; }
        if (additionalNetworkConnections === void 0) { additionalNetworkConnections = []; }
        var defaultNetworkId = getNetworkId(node.id, Network.DEFAULT);
        if (networkIdsPartial[defaultNetworkId])
            return;
        var edgeIds = node.attachmentIds
            .map(function (attachmentId) { var _a; return (_a = attachments[attachmentId]) === null || _a === void 0 ? void 0 : _a.edgeId; })
            .filter(Boolean);
        addToNetwork(node.id, Network.DEFAULT, edgeIds
            .map(function (id) { return getNetworkId(id, Network.DEFAULT); })
            .concat(additionalNetworkConnections));
        if (addToBlowOffNetwork) {
            addToNetwork(node.id, Network.BLOW_OFF, edgeIds.map(function (id) { return getNetworkId(id, Network.BLOW_OFF); }));
        }
        edgeIds.forEach(function (edgeId) {
            var edge = edges[edgeId];
            var fromAttachment = edge && attachments[edge.fromAttachmentId];
            var toAttachment = edge && attachments[edge.toAttachmentId];
            /* Skip a dangling edge that references a missing edge/attachment, so a
             * half-connected tube can never crash request serialization. */
            if (!edge || !fromAttachment || !toAttachment)
                return;
            var connectedNode = fromAttachment.nodeId === node.id
                ? nodes[toAttachment.nodeId]
                : nodes[fromAttachment.nodeId];
            /*
             * When we encounter an edge that is connected to a central pump
             * or grip position, the blow off tube network ends and the
             * blow off tube will be connected to the pump/grip position on
             * the default network.
             * From that point forward, we will only have the default network.
             */
            var continueBlowOffNetwork = addToBlowOffNetwork &&
                connectedNode.type !== NodeComponentType.CENTRALIZED_VACUUM_PUMP &&
                connectedNode.type !== NodeComponentType.GRIP_POSITION;
            var connectBlowOffEdgeToDefaultNode = addToBlowOffNetwork && !continueBlowOffNetwork;
            var edgeDefaultNetworkId = getNetworkId(edgeId, Network.DEFAULT);
            var edgeBlowOffNetworkId = getNetworkId(edgeId, Network.BLOW_OFF);
            if (!networkIdsPartial[edgeDefaultNetworkId]) {
                addToNetwork(edgeId, Network.DEFAULT, [
                    getNetworkId(node.id, Network.DEFAULT),
                    getNetworkId(connectedNode.id, Network.DEFAULT),
                ]);
                if (addToBlowOffNetwork) {
                    addToNetwork(edgeId, Network.BLOW_OFF, [
                        getNetworkId(node.id, Network.BLOW_OFF),
                        getNetworkId(connectedNode.id, continueBlowOffNetwork ? Network.BLOW_OFF : Network.DEFAULT),
                    ]);
                }
            }
            populatePartialNetwork(connectedNode, continueBlowOffNetwork, connectBlowOffEdgeToDefaultNode ? [edgeBlowOffNetworkId] : []);
        });
    };
    var feedPressurePointNode = nodes[feedPressurePointNodeId];
    populatePartialNetwork(feedPressurePointNode, hasDoubleCompressedAirConnections);
    /*
     * Complete the simplified representation by adding the list
     * of API Ids the node/edge is connected to
     */
    var networkIds = Object.values(networkIdsPartial).reduce(function (allIds, currentIds) {
        allIds[currentIds.networkId] = __assign(__assign({}, currentIds), { apiConnections: currentIds.networkConnections.map(function (conn) { return networkIdsPartial[conn].apiId; }) });
        return allIds;
    }, {});
    var systemDataDefineParameters = selectors.selectSystemDataDefineParameters(state);
    if (!systemDataDefineParameters) {
        throw Error("System data undefined");
    }
    var parameters = systemDataDefineParameters.parameters;
    var calculationInput = systemDataDefineParameters.calculationInput;
    var parameterNames = systemDataConstants.parameterNames;
    var isCentralizedSystem = selectors.selectIsCentralizedSystem(state);
    var isMultiCircuitSystem = selectors.selectIsMultiCircuitSystem(state);
    var suctionCups = [];
    var suctionCupsMissingObject = [];
    var tubeConnectors = [];
    var vacuumPumps = [];
    var feedPressurePoints = [];
    var vacuumComponents = [];
    var flowRestrictors = [];
    var tubes = [];
    /* Populate the request data based on the id network and the node data */
    Object.values(networkIds).forEach(function (idMap) {
        var sceneId = idMap.sceneId, apiId = idMap.apiId, networkConnections = idMap.networkConnections, apiConnections = idMap.apiConnections, network = idMap.network;
        var node = nodes[sceneId];
        if (node && node.type === NodeComponentType.FEED_PRESSURE_POINT) {
            feedPressurePoints.push({
                id: apiId,
                connections: apiConnections,
                feed_pressure: Number(parameters[parameterNames.feedPressure].value),
                type: network === Network.DEFAULT
                    ? FeedPressureType.EJECTOR
                    : FeedPressureType.BLOW_OFF,
            });
        }
        else if (node &&
            node.type === NodeComponentType.CENTRALIZED_VACUUM_PUMP &&
            isCentralizedSystem) {
            var selectedPump = selectors.selectSelectedCentralPump(node.id)(state);
            if (selectedPump) {
                vacuumPumps.push(__assign({ id: apiId, connections: apiConnections }, getPumpProperties(selectedPump)));
            }
        }
        else if (node && node.type === NodeComponentType.GRIP_POSITION) {
            var cup_1 = selectors.selectSelectedCup(node.id)(state);
            var pump_1 = selectors.selectSelectedDecentralPump(node.id)(state);
            var cupMounting_1 = selectors.selectSelectedCupMounting(node.id)(state);
            var cupTechnology_1 = selectors.selectSelectedCupTechnology(node.id)(state);
            var gripPosition_1 = node.component;
            /* Grip position nodes are split into four potential API nodes; one for the pump,
             * one for the cup mounting, one for a flow restrictor/cup technology and one for the cup.
             */
            var pushStack_1 = [
                // note that the order of the items here are important. It will determine how things are connected. If there is both a cupMounting and a cupTechnology then the tube will be considered connected to the mounting and the cupTechnology will be considered connected to the cupMounting. If there is no cupMounting the tube will be connected to the cupTechnology.
                !isCentralizedSystem && pump_1
                    ? function (id, connections) {
                        return vacuumPumps.push(__assign({ id: id, connections: connections }, getPumpProperties(pump_1)));
                    }
                    : undefined,
                !isCentralizedSystem && pump_1 && pump_1.isInlineDecentralPump
                    ? function (id, connections) {
                        return tubes.push({
                            id: id,
                            connections: connections,
                            length: gripPosition_1.inlineTubeLength,
                            diameter: gripPosition_1.inlineTubeDiameter,
                        });
                    }
                    : undefined,
                cupMounting_1
                    ? function (id, connections) {
                        return vacuumComponents.push(__assign({ id: id, connections: connections }, getCupMountingProperties(cupMounting_1)));
                    }
                    : undefined,
                cupTechnology_1
                    ? function (id, connections) {
                        return flowRestrictors.push({
                            id: id,
                            connections: connections,
                            model: cupTechnology_1.cupTechId,
                            volume: cupTechnology_1.volume,
                        });
                    }
                    : undefined,
                cup_1
                    ? function (id, connections) {
                        var isOutsideOfObject = cupsOutsideOfObject.find(function (cupId) { return cupId === node.id; });
                        if (isOutsideOfObject) {
                            suctionCupsMissingObject.push(__assign({ id: id, connections: __spreadArray(__spreadArray([], __read(connections), false), [noHandledObjectId], false) }, getCupProperties(cup_1)));
                        }
                        else {
                            suctionCups.push(__assign({ id: id, connections: __spreadArray(__spreadArray([], __read(connections), false), [handledObjectId], false) }, getCupProperties(cup_1)));
                        }
                    }
                    : undefined,
            ].filter(Boolean);
            var additionalApiIds_1 = [];
            var currentApiId_1 = apiId;
            var currentConnections_1 = apiConnections;
            pushStack_1.forEach(function (pushFn, ix) {
                var nextApiId = ix < pushStack_1.length - 1 ? getId() : undefined;
                if (nextApiId) {
                    currentConnections_1.push(nextApiId);
                    additionalApiIds_1.push(nextApiId);
                }
                pushFn(currentApiId_1, currentConnections_1);
                if (nextApiId) {
                    currentConnections_1 = [currentApiId_1];
                    currentApiId_1 = nextApiId;
                }
            });
            idMap.additionalApiIds = additionalApiIds_1;
        }
        else if (node && node.type === NodeComponentType.TUBE_CONNECTION) {
            var component = node.component;
            var tubeConnectionModel = tubeConnectionModels[component.type];
            // Piab expects only one diameter and that is the largest diameter that the tube
            // connection is connected to
            var largestDiameter = Math.max.apply(Math, __spreadArray([], __read(component.diameters), false));
            /* All tube connections are represented as one node in this application, but the API
             * does not handle double-T connections so when this is selected we need to split
             * it into two single-T nodes with different IDs. The two nodes will be connected
             * to each other and the edges will be split so that one node gets the first two
             * edges and the other get the last two edges.
             */
            if (tubeConnectionModel.type === "tube-connection" &&
                tubeConnectionModel.isDouble) {
                var apiId1 = apiId;
                var apiId2_1 = getId();
                tubeConnectors.push({
                    id: apiId1,
                    connections: __spreadArray(__spreadArray([], __read(apiConnections.slice(0, 2)), false), [apiId2_1], false),
                    model: TubeConnectionId.THREE_WAY_T,
                    diameter: largestDiameter,
                });
                tubeConnectors.push({
                    id: apiId2_1,
                    connections: __spreadArray(__spreadArray([], __read(apiConnections.slice(2, 4)), false), [apiId1], false),
                    model: TubeConnectionId.THREE_WAY_T,
                    diameter: largestDiameter,
                });
                networkConnections.slice(2, 4).forEach(function (networkId) {
                    var edgeIds = networkIds[networkId];
                    var indexOfTubeConn = edgeIds.apiConnections.indexOf(apiId);
                    if (indexOfTubeConn > -1)
                        edgeIds.apiConnections[indexOfTubeConn] = apiId2_1;
                });
                idMap.additionalApiIds = [apiId2_1];
            }
            else if (tubeConnectionModel.type === "tool-changer") {
                vacuumComponents.push({
                    id: apiId,
                    connections: apiConnections,
                    model: component.type,
                    diameter: largestDiameter,
                    volume: getCylinderVolumeDm3(toolChangerDefaultLength, largestDiameter),
                });
            }
            else {
                tubeConnectors.push({
                    id: apiId,
                    connections: apiConnections,
                    model: component.type,
                    diameter: largestDiameter,
                    volume: tubeConnectionModel.type === "distribution-block"
                        ? tubeConnectionModel.volume_dm3
                        : undefined,
                });
            }
        }
    });
    /* Populate the request data tubes based on the id network and the edge data */
    Object.values(networkIds).forEach(function (idMap) {
        var sceneId = idMap.sceneId, apiId = idMap.apiId, apiConnections = idMap.apiConnections;
        var edge = edges[sceneId];
        if (edge) {
            tubes.push({
                id: apiId,
                connections: apiConnections,
                length: edge.length,
                diameter: edge.diameterDefaultTube,
            });
        }
    });
    /* Map all created API IDs to scene IDs */
    var apiIdToNodeId = Object.values(networkIds).reduce(function (apiToNodeMap, currentIdMap) {
        var _a;
        apiToNodeMap[currentIdMap.apiId] = currentIdMap.sceneId;
        (_a = currentIdMap.additionalApiIds) === null || _a === void 0 ? void 0 : _a.forEach(function (apiId) { return (apiToNodeMap[apiId] = currentIdMap.sceneId); });
        return apiToNodeMap;
    }, {});
    var getSystemModel = function () {
        if (isMultiCircuitSystem)
            return SystemModel.MULTI_CIRCUIT;
        if (isCentralizedSystem)
            return SystemModel.CENTRALIZED;
        return SystemModel.DECENTRALIZED;
    };
    var surfaceRoughness = calculationInput.surfaceRoughness, throughLeak = calculationInput.throughLeak, handledObjectType = calculationInput.handledObjectType, surfaceStructure = calculationInput.surfaceStructure, surfaceCoating = calculationInput.surfaceCoating;
    var manualCalculationInput = selectors.selectManualCalculationInput(state);
    var manualSurfaceRoughness = manualCalculationInput && manualCalculationInput.manualSurfaceRoughness;
    var manualThroughLeak = manualCalculationInput && manualCalculationInput.manualThroughLeak;
    var handled_objects = [
        {
            id: handledObjectId,
            connections: suctionCups.map(function (cup) { return cup.id; }),
            object_type: handledObjectType,
            surface_roughness: manualSurfaceRoughness !== undefined
                ? manualSurfaceRoughness
                : surfaceRoughness,
            surface_structure: surfaceStructure,
            through_leak: manualThroughLeak !== undefined ? manualThroughLeak : throughLeak,
            surface_coating: surfaceCoating,
        },
    ];
    if (suctionCupsMissingObject.length > 0) {
        handled_objects.push({
            id: noHandledObjectId,
            connections: suctionCupsMissingObject.map(function (cup) { return cup.id; }),
            object_type: "NOMATERIAL",
            surface_roughness: 0,
            surface_structure: "",
            through_leak: 0,
            surface_coating: "NO",
        });
    }
    return {
        request: {
            suction_cups: __spreadArray(__spreadArray([], __read(suctionCups), false), __read(suctionCupsMissingObject), false),
            vacuum_pumps: vacuumPumps,
            tubes: tubes,
            tube_connectors: tubeConnectors,
            feed_pressure_points: feedPressurePoints,
            vacuum_components: vacuumComponents,
            flow_restrictions: flowRestrictors,
            system_property: {
                part_secured_level: Number(parameters[parameterNames.partSecuredLevel].value),
                energy_saving_level: energySavingOn
                    ? Number(parameters[parameterNames.energySavingLevel].value)
                    : 101.3,
                energy_saving_restart_level: energySavingOn
                    ? Number(parameters[parameterNames.energySavingRestartLevel].value)
                    : 101.3,
                blow_off_clearance_time: Number(parameters[parameterNames.blowOffClearanceTime].value),
                target_parts_per_minute: Number(parameters[parameterNames.targetPartsPerMinute].value),
                vacuum_on_before_pick: Number(parameters[parameterNames.vacuumOnBeforePick].value),
                blow_off_on_before_pick: Number(parameters[parameterNames.blowOffOnBeforePick].value),
                system_model: getSystemModel(),
            },
            handled_objects: handled_objects,
            sanity_check: {
                make_sanity_check: false,
            },
        },
        apiIdToNodeId: apiIdToNodeId,
    };
};
